<div class="modal-backdrop">
    <div class="modal-box scrollable">
        <form #phaseForm="ngForm">
            <h4>{{ phaseData?.id ? 'Modifica fase' : 'Nuova fase' }}</h4>

            <label>Nome *</label>
            <input [(ngModel)]="phaseData.name" name="name" required />

            <label>
                Descrizione lunga *
                <mat-icon
                    matTooltip="Testo che verrà utilizzato in fase di creazione del preventivo dalla document composition."
                    fontIcon="info" style="font-size:16px; vertical-align: middle; cursor: pointer; color: #555;">
                </mat-icon>
            </label>
            <textarea [(ngModel)]="phaseData.desL" name="desL" rows="3" required></textarea>


            <label>Numero lavoratori</label>
            <input type="number" [(ngModel)]="phaseData.nWorkers" name="nWorkers" onwheel="this.blur()" />

            <label>
                Produzione oraria *
                <mat-icon
                    matTooltip="Parametro che indica quanto una squadra di due persone produce in un'ora. Determina, in base alla quantità a preventivo, il numero di ore necessarie a completare la lavorazione. Richiede obbligatoriamente l'unità di misura, che verrà mostrata nel frontend per ogni fase."
                    fontIcon="info" style="font-size:16px; vertical-align: middle; cursor: pointer; color: #555;">
                </mat-icon>
            </label>
            <input type="number" [(ngModel)]="phaseData.qProdOraria" name="qProdOraria" required
                onwheel="this.blur()" />


            <label>
                Costo materiale *
                <mat-icon
                    matTooltip="Costo del materiale per produrre un'unità singola della lavorazione (es. 1 mq, 1 ml, 1 mc, 1 unità, ecc.)."
                    fontIcon="info" style="font-size:16px; vertical-align: middle; cursor: pointer; color: #555;">
                </mat-icon>
            </label>
            <input type="number" [(ngModel)]="phaseData.cMater" name="cMater" required onwheel="this.blur()" />

            <label>Prezzo fisso</label>
            <input type="number" [(ngModel)]="phaseData.FixedPrice" name="FixedPrice" onwheel="this.blur()" />

            <mat-form-field appearance="fill" class="full-width field-margin">
                <mat-label>Unità di misura</mat-label>
                <mat-select [(ngModel)]="phaseData.UnitMeasureIdId" name="UnitMeasureIdId" required>
                    <mat-option [value]="null" disabled>-- Seleziona un'unità --</mat-option>
                    <mat-option *ngFor="let unit of unitMeasures" [value]="unit.id">
                        {{ unit.uiLabel }}
                    </mat-option>
                </mat-select>
            </mat-form-field>



            <label>Posizione *</label>
            <input type="number" [(ngModel)]="phaseData.position" name="position" required onwheel="this.blur()" />

            <div class="checkbox-row">
                <input type="checkbox" [(ngModel)]="phaseData.isActive" id="isActive" name="isActive" />
                <label for="isActive">
                    Attiva
                    <mat-icon
                        matTooltip="Se attivo: comparirà in preventivazione. Se disattivo: sarà visibile ma non cliccabile."
                        fontIcon="info" style="font-size:16px; vertical-align: middle; cursor: pointer; color: #555;">
                    </mat-icon>
                </label>
            </div>

            <div class="checkbox-row">
                <input type="checkbox" [(ngModel)]="phaseData.isVisible" id="isVisible" name="isVisible" />
                <label for="isVisible">
                    Visibile
                    <mat-icon
                        matTooltip="Se visibile: comparirà in preventivazione. Se non visibile: non verrà mostrato."
                        fontIcon="info" style="font-size:16px; vertical-align: middle; cursor: pointer; color: #555;">
                    </mat-icon>
                </label>
            </div>

            <!-- Avviso -->
            <div *ngIf="phaseData.isActive && !phaseData.isVisible" class="warning-message">
                Attenzione: un elemento attivo ma non visibile non sarà comunque mostrato in preventivazione.
            </div>


            <div class="checkbox-row">
                <input type="checkbox" [(ngModel)]="phaseData.isPercAmmaloramento" id="isPercAmmaloramento"
                    name="isPercAmmaloramento" />
                <label for="isPercAmmaloramento">Ammaloramento</label>
            </div>

            <div class="checkbox-row">
                <input type="checkbox" [(ngModel)]="phaseData.isAdditionalMaterialCost" id="isAdditionalMaterialCost"
                    name="isAdditionalMaterialCost" />
                <label for="isAdditionalMaterialCost">Costo materiale aggiuntivo</label>
            </div>

            <div class="checkbox-row">
                <input type="checkbox" [(ngModel)]="phaseData.isPreselected" id="isPreselected" name="isPreselected" />
                <label for="isPreselected">Preselezionato</label>
            </div>

            <div class="checkbox-row">
                <input type="checkbox" [(ngModel)]="phaseData.isOtherCost" id="isOtherCost" name="isOtherCost" />
                <label for="isOtherCost">Altro costo</label>
            </div>

            <div class="checkbox-row">
                <input type="checkbox" [(ngModel)]="phaseData.isOpereSpeciali" id="isOpereSpeciali"
                    name="isOpereSpeciali" />
                <label for="isOpereSpeciali">Opere speciali</label>
            </div>

            <div class="checkbox-row">
                <input type="checkbox" [(ngModel)]="phaseData.isMandatory" id="isMandatory" name="isMandatory" />
                <label for="isMandatory">Obbligatorio</label>
            </div>

            <div class="checkbox-row">
                <input type="checkbox" [(ngModel)]="phaseData.isFixedPrice" id="isFixedPrice" name="isFixedPrice" />
                <label for="isFixedPrice">Prezzo fisso (bloccato)</label>
            </div>

            <hr class="section-divider" />

            <!-- Readonly -->
            <label>Lingua</label>
            <input [(ngModel)]="phaseData.codLanguage" name="codLanguage" readonly />

            <label>Nazione</label>
            <input [(ngModel)]="phaseData.codCountry" name="codCountry" readonly />

            <label>Creato il</label>
            <input [(ngModel)]="phaseData.createdAt" name="createdAt" readonly />

            <label>Ultima modifica</label>
            <input [(ngModel)]="phaseData.updatedAt" name="updatedAt" readonly />

            <div class="modal-buttons">
                <button type="button" (click)="onSave()"
                    [disabled]="!phaseForm.form.valid || isUnchanged()">Salva</button>
                <button type="button" (click)="onClose()" class="cancel">Chiudi</button>
            </div>
        </form>
    </div>
</div>